import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import EmojiTransportationOutlinedIcon from '@mui/icons-material/EmojiTransportationOutlined'
import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'

import MyMoveLogoIcon from './MyMoveLogoIcon'
import EnumIconSelectInput, { EnumField } from '../../components/EnumIconSelectInput'
import {
  EMBEDDED_EQUIPMENT_INCIDENT_REPORT_CATEGORIES,
  INCIDENT_REPORT_OWNERSHIP_FLEET_MANAGER,
  INCIDENT_REPORT_OWNERSHIP_LEASING_COMPANY,
  INCIDENT_REPORT_OWNERSHIP_MYMOVE,
} from '../../config/damages'

export const INCIDENT_REPORT_OWNER_UI_CONFIG = {
  [INCIDENT_REPORT_OWNERSHIP_MYMOVE]: {
    icon: MyMoveLogoIcon,
  },
  [INCIDENT_REPORT_OWNERSHIP_FLEET_MANAGER]: {
    icon: BusinessOutlinedIcon,
  },
  [INCIDENT_REPORT_OWNERSHIP_LEASING_COMPANY]: {
    icon: EmojiTransportationOutlinedIcon,
  },
}

export const INCIDENT_REPORT_OWNERSHIP_CHOICES = [
  {
    id: INCIDENT_REPORT_OWNERSHIP_FLEET_MANAGER,
    icon: BusinessOutlinedIcon,
  },
  {
    id: INCIDENT_REPORT_OWNERSHIP_LEASING_COMPANY,
    icon: EmojiTransportationOutlinedIcon,
    iconSize: 18,
  },
  {
    id: INCIDENT_REPORT_OWNERSHIP_MYMOVE,
    icon: MyMoveLogoIcon,
  },
]

export const IncidentOwnershipField = (props) => (
  <EnumField resource="incident-reports" source="ownership" choices={INCIDENT_REPORT_OWNERSHIP_CHOICES} {...props} />
)

export const getDamageOwnershipChoices = (category = null) => {
  if (!category) return INCIDENT_REPORT_OWNERSHIP_CHOICES
  if (EMBEDDED_EQUIPMENT_INCIDENT_REPORT_CATEGORIES.includes(category)) {
    return INCIDENT_REPORT_OWNERSHIP_CHOICES.filter((choice) =>
      [INCIDENT_REPORT_OWNERSHIP_MYMOVE, INCIDENT_REPORT_OWNERSHIP_FLEET_MANAGER].includes(choice.id),
    )
  }
  return INCIDENT_REPORT_OWNERSHIP_CHOICES.filter((choice) =>
    [INCIDENT_REPORT_OWNERSHIP_FLEET_MANAGER, INCIDENT_REPORT_OWNERSHIP_LEASING_COMPANY].includes(choice.id),
  )
}

export const getDamageOwnershipIcon = (ownershipId) =>
  INCIDENT_REPORT_OWNER_UI_CONFIG[ownershipId]?.icon || BusinessOutlinedIcon

const OwnershipSelectInput = ({ excludeValues = [], ...props }) => {
  const category = useWatch({ name: 'category' })
  const choices = useMemo(() => {
    const baseChoices = getDamageOwnershipChoices(category)
    return excludeValues.length ? baseChoices.filter((choice) => !excludeValues.includes(choice.id)) : baseChoices
  }, [category, excludeValues])

  return <EnumIconSelectInput source="ownership" choices={choices} {...props} />
}

export default OwnershipSelectInput
